import { useEffect, useEffectEvent } from 'react';

import { useNavigate } from 'react-router';

import { StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';

export const useTokenExpiry = () => {
  const navigate = useNavigate();
  const gxToken = useStorageValue(StorageKeys.GxToken);
  const expiryTime = useStorageValue(StorageKeys.TokenExpiry);

  const isExpired = useEffectEvent(() => {
    if (!expiryTime) return true; // No expiry set, treat as expired

    const now = Math.floor(Date.now() / 1000);
    const timeUntilExpiry = expiryTime - now;

    return timeUntilExpiry <= 0;
  });

  useEffect(() => {
    if (!gxToken) {
      return;
    }
    // Check immediately on mount
    if (isExpired()) {
      navigate('/logout');
      return;
    }

    // Check every minute
    const interval = setInterval(() => {
      if (isExpired()) {
        navigate('/logout');
      }
    }, 6000);

    return () => {
      clearInterval(interval);
    };
  }, [navigate, gxToken]);
};
